import React from "react";
import { Loading } from "../../components";
import { AffiliateSettingInterface, CommissionRowInterface, DateHelper } from "../../helpers";


interface Props {
  affiliateSetting: AffiliateSettingInterface
  checkId?: number;
  actionName?: string;
  onAction?: (rows: CommissionRowInterface[], affiliateSetting: AffiliateSettingInterface) => void
  rowsToAdd?: CommissionRowInterface[];
  commissions: CommissionRowInterface[];
}

export const Commissions: React.FC<Props> = props => {

  const [commissions, setCommissions] = React.useState<CommissionRowInterface[]>(null);

  const init = async () => {
    if (props.affiliateSetting) {
      setCommissions(props.commissions);
    }
  }

  const handleAction = (rows: CommissionRowInterface[]) => {
    const comms = [...commissions];
    for (let i = comms.length - 1; i >= 0; i--) {
      let remove = false;
      for (let row of rows) {
        if (comms[i].invoiceId === row.invoiceId) remove = true;
      }
      if (remove) comms.splice(i, 1);
    }
    setCommissions(comms);
    props.onAction(rows, props.affiliateSetting);
  }


  React.useEffect(() => { init() }, [props.affiliateSetting]); //eslint-disable-line
  React.useEffect(() => {
    if (props.rowsToAdd) {
      let comm = [...commissions];
      comm = comm.concat(props.rowsToAdd);
      setCommissions(comm);
    }
  }, [props.rowsToAdd]); //eslint-disable-line

  if (!commissions) return <Loading />
  else if (commissions.length === 0) return <p>You do not have any commission for {props.affiliateSetting?.code}.</p>
  else {
    const formatter = Intl.NumberFormat("en-US", { style: "currency", currency: "USD" });
    const rows: JSX.Element[] = [];
    let sum = 0;
    commissions.forEach(c => {
      const comm = c;
      const d = DateHelper.convertToDateOnly(c.startDate);
      sum += c.totalCommission
      rows.push(<tr key={comm.invoiceId}>
        <td>{c.name}</td>
        <td>{DateHelper.formatDateTime(d, "MMM yyyy")}</td>
        <td>{formatter.format(c.totalCommission)}</td>
        {props.onAction && <td><a href="about:blank" onClick={(e) => { e.preventDefault(); handleAction([comm]); }}>{props.actionName}</a></td>}
      </tr>);
    });
    rows.push(<tr>
      <td><b>Total</b></td>
      <td></td>
      <td><b>{formatter.format(sum)}</b></td>
      {props.onAction && <td><a href="about:blank" onClick={(e) => { e.preventDefault(); handleAction([...commissions]); }}>{props.actionName} All</a></td>}
    </tr>)

    return (<>
      <b>{props.affiliateSetting?.code}</b><br />
      <table className="table table-sm table-sriped" >
        <thead>
          <tr>
            <th>Name</th>
            <th>Month</th>
            <th>Commission</th>
            {props.onAction && <th>{props.actionName}</th>}
          </tr>
        </thead>
        <tbody>
          {rows}
        </tbody>
      </table>
    </>);
  }
};